import { render, staticRenderFns } from "./estado.vue?vue&type=template&id=00dd3cd2&"
import script from "./estado.vue?vue&type=script&lang=js&"
export * from "./estado.vue?vue&type=script&lang=js&"
import style0 from "./estado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports